import * as actionTypes from "./actionTypes";
import _ from '../shared/utils/ObjectUtils';
import { combineReducers } from 'redux';
import chartConfigsReducer from './widgetsSagas/chart/reducer';

const initialState = {
    loading: false,
    error: false,
    layout: [],
    widgets: {},
    dashboard: {},
    realTimeInterfaces: [],
    realTimeInterfacesData: {},
    widgetsData: {},
    entitiesTree: {},

    loadingWidgetCreateRequest: false,
    loadingWidgetEditRequest: false,
    loadingWidgetDeleteRequest: false,
    loadingWidgetDuplicateRequest: false,
    loadingDashboardEntitiesTreeRequest: false,

    widgetWasCreated: false,
    widgetWasEdited: false,
    widgetWasDeleted: false,
    widgetWasDuplicated: false,
};

const dashboardReducer = (state = initialState, payload) => {
    switch (payload.type) {
        case actionTypes.GET_DASHBOARD_INFO_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.GET_DASHBOARD_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                widgets: payload.widgets,
                layout: generateGridLayout(payload.dashboard.widgets),
                dashboard: payload.dashboard
            };
        case actionTypes.GET_DASHBOARD_INFO_FAILED:
            return {
                ...state,
                loading: false,
                error: true
            };

        case actionTypes.UPDATE_REAL_TIME_INTERFACES_DATA_REQUEST:
            return {
                ...state,
                realTimeInterfaces: payload.interfaceIds
            };

        case actionTypes.UPDATE_LAYOUT:
            let layout = state.layout.map(widget => {
                let indexOfWidgetToUpdate = payload.widgetsToUpdate.findIndex(widgetToUpdate => widgetToUpdate.i === widget.i);
                if (indexOfWidgetToUpdate === -1) {
                    return widget;
                }
                return {
                    ...widget,
                    x: payload.widgetsToUpdate[indexOfWidgetToUpdate].x,
                    y: payload.widgetsToUpdate[indexOfWidgetToUpdate].y,
                    h: payload.widgetsToUpdate[indexOfWidgetToUpdate].h,
                    w: payload.widgetsToUpdate[indexOfWidgetToUpdate].w
                }
            });

            payload.widgetsCreated.forEach(widget => {
                layout.push({
                    x: widget.x,
                    y: widget.y,
                    h: widget.h,
                    w: widget.w,
                    i: widget.i,
                });
            });

            const newLayout = layout.filter(widget => {
                const widgetsToDeleteIds = payload.widgetsDeleted.map(widgetToDelete => widgetToDelete.i);
                return !widgetsToDeleteIds.includes(widget.i)
            });

            return {
                ...state,
                layout: newLayout,
                widgets: {
                    ...state.widgets,
                    ...payload.widgetsToUpdate.reduce(
                        (acc, widgetToUpdate) => ({
                            ...acc,
                            [widgetToUpdate.i]: {
                                ...state.widgets[widgetToUpdate.i],
                                configs: {
                                    ...state.widgets[widgetToUpdate.i].configs,
                                    rowIndex: widgetToUpdate.y,
                                    columnIndex: widgetToUpdate.x,
                                    widgetHeight: widgetToUpdate.h,
                                    widgetWidth: widgetToUpdate.w
                                }
                            }
                        }),
                        {}
                    )
                }
            };
        case actionTypes.UPDATE_REAL_TIME_INTERFACES_DATA_SUCCESS:
            return {
                ...state,
                realTimeInterfacesData: {
                    ...state.realTimeInterfacesData,
                    ...payload.readings.reduce(
                        (acc, reading) => ({
                            ...acc,
                            [reading.interfaceId]: {
                                value: reading.value,
                                timestamp: reading.timestamp,
                                maxValue: reading.maxValue,
                                minValue: reading.minValue
                            }
                        }),
                        {}
                    )
                }
            };
        case actionTypes.DELETE_WIDGET_REQUEST:
            return {
                ...state,
                loadingWidgetDeleteRequest: true,
            };
        case actionTypes.DELETE_WIDGET_SUCCESS:
            return {
                ...state,
                loadingWidgetDeleteRequest: false,
                widgetWasDeleted: true,
                widgets: {
                    ...Object.keys(state.widgets).reduce((acc, key) => {
                        if (key !== (payload.widget.id)) {
                            return {
                                ...acc,
                                [key]: state.widgets[key]
                            }
                        }
                        return acc;
                    }, {})
                }
            };
        case actionTypes.DELETE_WIDGET_FAILED:
            return {
                ...state,
                loadingWidgetDeleteRequest: false,
                widgetWasDeleted: false
            };
        case actionTypes.EDIT_WIDGET_REQUEST:
            return {
                ...state,
                loadingWidgetEditRequest: true
            };
        case actionTypes.EDIT_WIDGET_SUCCESS:

            const widgetsToUpdate = state.widgets;
            widgetsToUpdate[payload.updatedWidget.id] = payload.updatedWidget;

            return {
                ...state,
                loadingWidgetEditRequest: false,
                widgetWasEdited: true,
                widgets: widgetsToUpdate
            };
        case actionTypes.EDIT_WIDGET_FAILED:
            return {
                ...state,
                loadingWidgetEditRequest: false,
                widgetWasEdited: false
            };
        case actionTypes.CREATE_WIDGET_REQUEST:
            return {
                ...state,
                loadingWidgetCreateRequest: true
            };
        case actionTypes.CREATE_WIDGET_SUCCESS:

            const widgets = state.widgets;
            widgets[payload.newWidget.id] = payload.newWidget;

            return {
                ...state,
                loadingWidgetCreateRequest: false,
                widgetWasCreated: true,
                widgets: widgets
            };
        case actionTypes.CREATE_WIDGET_FAILED:
            return {
                ...state,
                loadingWidgetCreateRequest: false,
                widgetWasCreated: false
            };
        case actionTypes.DUPLICATE_WIDGET_REQUEST:
            return {
                ...state,
                loadingWidgetDuplicateRequest: true
            };
        case actionTypes.DUPLICATE_WIDGET_SUCCESS:

            const updatedWidgets = state.widgets;
            updatedWidgets[payload.newWidget.id] = payload.newWidget;

            return {
                ...state,
                loadingWidgetDuplicateRequest: false,
                widgetWasDuplicated: true,
                widgets: updatedWidgets
            };
        case actionTypes.DUPLICATE_WIDGET_FAILED:
            return {
                ...state,
                loadingWidgetDuplicateRequest: false,
                widgetWasDuplicated: false
            };
        case actionTypes.GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_REQUEST:
            return {
                ...state,
                loadingDashboardEntitiesTreeRequest: true
            };
        case actionTypes.GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_SUCCESS:
            return {
                ...state,
                loadingDashboardEntitiesTreeRequest: false,
                entitiesTree: payload.entitiesTree
            };
        case actionTypes.GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_FAILED:
            return {
                ...state,
                loadingDashboardEntitiesTreeRequest: false,
                entitiesTree: []
            };
        case actionTypes.CLEAN_LAYOUT:
            return initialState;
        // ------- Async widgets data --------
        case actionTypes.LOAD_CHART_WIDGET_DATA_REQUEST:
        case actionTypes.LOAD_WIDGET_DATA_REQUEST:
            return {
                ...state,
                widgetsData: {
                    ...state.widgetsData,
                    [payload.id]: {
                        ...state.widgetsData[payload.id],
                        loading: true
                    }
                }
            };
        case actionTypes.LOAD_WIDGET_DATA_SUCCESS:
            return {
                ...state,
                widgetsData: {
                    ...state.widgetsData,
                    [payload.id]: {
                        ...state.widgetsData[payload.id],
                        data: payload.data,
                        error: false,
                        loading: false
                    }
                }
            };
        case actionTypes.LOAD_WIDGET_DATA_FAILED:
            return {
                ...state,
                widgetsData: {
                    ...state.widgetsData,
                    [payload.id]: {
                        ...state.widgetsData[payload.id],
                        data: {},
                        error: true,
                        loading: false
                    }
                }
            };
        default:
            return state;
    }
};

function generateGridLayout(widgets) {
    return widgets.map(widget => {
        return {
            i: widget.id,
            x: parseInt(widget.configs.columnIndex, 10),
            y: parseInt(widget.configs.rowIndex, 10),
            h: !_.isNil(widget.configs.widgetHeight) ? parseInt(widget.configs.widgetHeight, 10) : 4,
            w: !_.isNil(widget.configs.widgetWidth) ? parseInt(widget.configs.widgetWidth, 10) : 4,
            isResizable: true
        };
    });
}

export default combineReducers({
    dashboardReducer,
    chartConfigsReducer
});
